import { mutator } from 'satcheljs';
import { onAssetResizeStart, onAssetResizeEnd, showResizeHandles } from './actions';
import getStore from './store';
import { getAsset, getLastKnownBounds } from 'owa-timestream-store';

mutator(onAssetResizeStart, ({ projectId, assetId }) => {
    const store = getStore();
    const parentAssetId = getAsset(projectId, assetId).parentId;
    if (parentAssetId) {
        store.assetResizing = assetId;
        const parentAsset = getAsset(projectId, parentAssetId);
        let largestChildWidth = 0;
        let widestChild;
        parentAsset.children.forEach(child => {
            const childWidth = getLastKnownBounds(projectId, child)?.width ?? 0;
            if (childWidth > largestChildWidth) {
                largestChildWidth = childWidth;
                widestChild = child;
            }
        });
        store.assetResizingParent.widestChildSize = largestChildWidth;
        store.assetResizingParent.isResizingWidestChild = widestChild == assetId;
        store.assetResizingParent.initialPosition = {
            x: parentAsset.bounds.x,
            y: parentAsset.bounds.y,
        };
    }
});
mutator(onAssetResizeEnd, () => {
    const store = getStore();
    store.assetResizing = null;
    store.shouldShowResizeHandles = false;
    store.assetResizingParent = {
        widestChildSize: null,
        isResizingWidestChild: false,
        initialPosition: { x: null, y: null },
    };
});

mutator(showResizeHandles, ({ assetId }) => {
    const store = getStore();
    if (assetId !== store.assetResizing) {
        store.assetResizing = assetId;
    }
    store.shouldShowResizeHandles = true;
});
